import { ROUTES } from '@discover/utils/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/patterns/$patternId/'
)({
  beforeLoad({ params }) {
    throw redirect({ to: ROUTES.topics, params })
  },
})
